export default "__VITE_ASSET__DeFGEgMA__"